import { statusColors, statusNames } from '../../utils/historyStatus.utils';
import './status-table.css';

const StatusTable = ({ status }: { status: string }) => {
  return (
    <div className='status-table' style={{ color: statusColors[status] }}>
      {statusNames[status]}
    </div>
  );
};

export default StatusTable;
